export const STORE_PLATFORM_LABEL = "主商城";

const APPLYMENT_STATUS_TEXT = {
  0: "新增商户",
  10: "草稿",
  20: "审核中",
  30: "审核中",
  40: "待商户确认",
  50: "待支付检查",
  60: "已驳回",
  70: "已撤回",
};

const NEXT_ACTION_TEXT = {
  0: "提交审核",
  10: "提交审核",
  20: "同步状态",
  30: "同步状态",
  40: "商户确认",
  50: "支付检查",
  60: "修改资料",
  70: "重新新增",
};

const SUBMITTABLE_STATUS = [0, 10, 60];
const SYNCABLE_STATUS = [20, 30, 40, 50, 60];
const CONFIRMABLE_STATUS = [30, 40];

const MATERIAL_STATUS_TEXT = {
  pending: "待上传",
  uploaded: "已上传",
  recognizing: "识别中",
  recognized: "已识别，请核对",
  failed: "识别失败，请手动填写",
};

export const MODULES = [
  { key: "contact", title: "联系人 / 超级管理员" },
  { key: "subject", title: "主体资料" },
  { key: "business", title: "经营资料" },
  { key: "settlement", title: "行业资质 / 结算规则" },
  { key: "bank_account", title: "结算账户" },
  { key: "addition", title: "补充材料", optional: true },
];

const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const isEmptyValue = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0) ||
  (isPlainObject(value) && Object.keys(value).length === 0);

const fillIfEmpty = (target, key, value) => {
  if (value !== undefined && isEmptyValue(target[key])) {
    target[key] = cloneForm(value);
  }
};

const ensureObject = (target, key) => {
  if (!isPlainObject(target[key])) target[key] = {};
  return target[key];
};

const fillMediaIfEmpty = (form, type, mediaId) => {
  if (isEmptyValue(mediaId)) return;
  const files = ensureObject(form, "files");
  const material = ensureObject(files, type);
  fillIfEmpty(material, "media_id", mediaId);
};

const moveIfEmpty = (target, key, oldKey) => {
  fillIfEmpty(target, key, target[oldKey]);
  delete target[oldKey];
};

const moveFileIfEmpty = (form, key, oldKey) => {
  const files = ensureObject(form, "files");
  moveIfEmpty(files, key, oldKey);
};

const STANDARD_SUBJECT_TYPES = [
  "SUBJECT_TYPE_INDIVIDUAL",
  "SUBJECT_TYPE_ENTERPRISE",
  "SUBJECT_TYPE_GOVERNMENT",
  "SUBJECT_TYPE_INSTITUTIONS",
  "SUBJECT_TYPE_OTHERS",
];

const normalizeApplymentFields = (value) => {
  const form = cloneForm(value || {});
  if (!isPlainObject(form)) return {};

  if (isPlainObject(form.contact_info)) {
    const contact = ensureObject(form, "contact");
    [
      "contact_type",
      "contact_name",
      "mobile_phone",
      "contact_phone",
      "contact_email",
      "contact_id_doc_type",
      "contact_id_number",
      "contact_period_begin",
      "contact_period_end",
    ].forEach((key) => fillIfEmpty(contact, key, form.contact_info[key]));
    fillMediaIfEmpty(form, "contact_id_doc_copy", form.contact_info.contact_id_doc_copy);
    fillMediaIfEmpty(form, "contact_id_doc_copy_back", form.contact_info.contact_id_doc_copy_back);
    delete form.contact_info;
  }

  if (isPlainObject(form.subject_info)) {
    const subject = ensureObject(form, "subject");
    const subjectInfo = form.subject_info;
    fillIfEmpty(subject, "subject_type", subjectInfo.subject_type);

    if (isPlainObject(subjectInfo.business_license_info)) {
      fillIfEmpty(subject, "license_copy", subjectInfo.business_license_info.license_copy);
      fillIfEmpty(subject, "license_number", subjectInfo.business_license_info.license_number);
      fillIfEmpty(subject, "merchant_name", subjectInfo.business_license_info.merchant_name);
      fillIfEmpty(subject, "legal_person", subjectInfo.business_license_info.legal_person);
    }

    if (isPlainObject(subjectInfo.certificate_info)) {
      fillIfEmpty(subject, "license_copy", subjectInfo.certificate_info.cert_copy);
      fillIfEmpty(subject, "license_number", subjectInfo.certificate_info.cert_number);
      fillIfEmpty(subject, "merchant_name", subjectInfo.certificate_info.merchant_name);
      fillIfEmpty(subject, "legal_person", subjectInfo.certificate_info.legal_person);
      fillIfEmpty(subject, "registered_address", subjectInfo.certificate_info.company_address);
      fillIfEmpty(subject, "cert_type", subjectInfo.certificate_info.cert_type);
    }

    if (isPlainObject(subjectInfo.identity_info)) {
      fillIfEmpty(subject, "id_holder_type", subjectInfo.identity_info.id_holder_type);
      if (isPlainObject(subjectInfo.identity_info.id_card_info)) {
        fillIfEmpty(subject, "id_card_copy", subjectInfo.identity_info.id_card_info.id_card_copy);
        fillIfEmpty(subject, "id_card_national", subjectInfo.identity_info.id_card_info.id_card_national);
        fillIfEmpty(subject, "id_card_name", subjectInfo.identity_info.id_card_info.id_card_name);
        fillIfEmpty(subject, "id_card_number", subjectInfo.identity_info.id_card_info.id_card_number);
        fillIfEmpty(subject, "id_card_address", subjectInfo.identity_info.id_card_info.id_card_address);
        fillIfEmpty(subject, "card_period_begin", subjectInfo.identity_info.id_card_info.card_period_begin);
        fillIfEmpty(subject, "card_period_end", subjectInfo.identity_info.id_card_info.card_period_end);
      }
    }

    delete form.subject_info;
  }

  if (isPlainObject(form.subject)) {
    const subject = form.subject;

    if (isPlainObject(subject.business_license)) {
      fillIfEmpty(subject, "license_copy", subject.business_license.license_copy);
      fillIfEmpty(subject, "license_number", subject.business_license.license_number);
      fillIfEmpty(subject, "merchant_name", subject.business_license.merchant_name);
      fillIfEmpty(subject, "legal_person", subject.business_license.legal_person);
      delete subject.business_license;
    }

    if (isPlainObject(subject.identity)) {
      fillIfEmpty(subject, "id_holder_type", subject.identity.id_holder_type);
      if (isPlainObject(subject.identity.id_card)) {
        fillIfEmpty(subject, "id_card_copy", subject.identity.id_card.id_card_copy);
        fillIfEmpty(subject, "id_card_national", subject.identity.id_card.id_card_national);
        fillIfEmpty(subject, "id_card_name", subject.identity.id_card.id_card_name);
        fillIfEmpty(subject, "id_card_number", subject.identity.id_card.id_card_number);
        fillIfEmpty(subject, "id_card_address", subject.identity.id_card.id_card_address);
        fillIfEmpty(subject, "card_period_begin", subject.identity.id_card.card_period_begin);
        fillIfEmpty(subject, "card_period_end", subject.identity.id_card.card_period_end);
      }
      delete subject.identity;
    }

    moveIfEmpty(subject, "cert_type", "certificate_type");
  }

  if (isPlainObject(form.business_info)) {
    const business = ensureObject(form, "business");
    const businessInfo = form.business_info;
    fillIfEmpty(business, "merchant_shortname", businessInfo.merchant_shortname);
    fillIfEmpty(business, "service_phone", businessInfo.service_phone);

    if (isPlainObject(businessInfo.sales_info)) {
      fillIfEmpty(business, "sales_scenes_type", businessInfo.sales_info.sales_scenes_type);
      if (isPlainObject(businessInfo.sales_info.biz_store_info)) {
        const storeInfo = businessInfo.sales_info.biz_store_info;
        fillIfEmpty(business, "store_name", storeInfo.biz_store_name);
        fillIfEmpty(business, "address_code", storeInfo.biz_address_code);
        fillIfEmpty(business, "address", storeInfo.biz_store_address || storeInfo.biz_address);
        fillIfEmpty(business, "store_entrance_pic", storeInfo.store_entrance_pic);
        fillIfEmpty(business, "indoor_pic", storeInfo.indoor_pic);
        fillMediaIfEmpty(form, "store_entrance_pic", storeInfo.store_entrance_pic);
        fillMediaIfEmpty(form, "indoor_pic", storeInfo.indoor_pic);
      }
    }

    delete form.business_info;
  }

  if (isPlainObject(form.business)) {
    if (Array.isArray(form.business.sales_scenes_type)) {
      form.business.sales_scenes_type = form.business.sales_scenes_type.map((scene) =>
        scene === "SALES_SCENES_ENTERPRISE_WECHAT" ? "SALES_SCENES_WEWORK" : scene
      );
    }
    fillIfEmpty(form.business, "address_code", form.business.store_address_code);
    fillIfEmpty(form.business, "address", form.business.store_address);
    moveIfEmpty(form.business, "sub_corp_id", "enterprise_wechat_corpid");
    delete form.business.store_address_code;
    delete form.business.store_address;
  }

  if (isPlainObject(form.settlement_info)) {
    const settlement = ensureObject(form, "settlement");
    Object.keys(form.settlement_info).forEach((key) => {
      fillIfEmpty(settlement, key, form.settlement_info[key]);
    });
    delete form.settlement_info;
  }

  if (isPlainObject(form.bank_account_info)) {
    const bankAccount = ensureObject(form, "bank_account");
    Object.keys(form.bank_account_info).forEach((key) => {
      fillIfEmpty(bankAccount, key, form.bank_account_info[key]);
    });
    delete form.bank_account_info;
  }

  moveFileIfEmpty(form, "web_authorisation", "web_authorization_letter");
  moveFileIfEmpty(form, "wework_pics", "enterprise_wechat_pics");
  if (!isPlainObject(form.addition_info)) {
    form.addition_info = {};
  }

  return form;
};

const deepMerge = (target, source, options = {}) => {
  if (!isPlainObject(source)) return target;

  Object.keys(source).forEach((key) => {
    const value = source[key];
    if (options.skipEmpty && isEmptyValue(value)) return;

    if (isPlainObject(value)) {
      const base = isPlainObject(target[key]) ? target[key] : {};
      target[key] = deepMerge(base, value, options);
      return;
    }

    target[key] = cloneForm(value);
  });

  return target;
};

export const cloneForm = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => cloneForm(item));
  }

  if (isPlainObject(value)) {
    return Object.keys(value).reduce((result, key) => {
      result[key] = cloneForm(value[key]);
      return result;
    }, {});
  }

  return value;
};

export const emptyForm = () => ({
  applyment_type: "standard",
  store_id: 0,
  contact: {
    contact_type: "LEGAL",
    contact_name: "",
    contact_id_doc_type: "IDENTIFICATION_TYPE_IDCARD",
    contact_id_number: "",
    contact_period_begin: "",
    contact_period_end: "",
    contact_period_long_term: 0,
    mobile_phone: "",
    contact_phone: "",
    contact_email: "",
  },
  subject: {
    subject_type: "SUBJECT_TYPE_ENTERPRISE",
    license_copy: "",
    license_number: "",
    merchant_name: "",
    registered_address: "",
    cert_type: "",
    legal_person: "",
    id_holder_type: "LEGAL",
    id_card_copy: "",
    id_card_national: "",
    id_card_name: "",
    id_card_number: "",
    id_card_address: "",
    card_period_begin: "",
    card_period_end: "",
    card_period_long_term: 0,
  },
  business: {
    merchant_shortname: "",
    service_phone: "",
    sales_scenes_type: ["SALES_SCENES_MINI_PROGRAM"],
    mini_program_sub_appid: "",
    store_name: "",
    address_code: "",
    address: "",
    mp_appid: "",
    app_appid: "",
    domain: "",
    web_appid: "",
    sub_corp_id: "",
  },
  settlement: {
    settlement_id: "",
    industry_id: "",
    qualification_type: "",
    qualifications: [],
  },
  bank_account: {
    bank_account_type: "BANK_ACCOUNT_TYPE_CORPORATE",
    account_name: "",
    account_bank: "",
    account_bank_code: "",
    bank_alias: "",
    bank_alias_code: "",
    need_bank_branch: 1,
    bank_province_code: "",
    bank_address_code: "",
    bank_name: "",
    bank_branch_id: "",
    bank_branch_name: "",
    account_number: "",
  },
  files: {},
  ocr_snapshots: {},
  account_confirm_info: {},
  addition_info: {
    description: "",
  },
});

export const mergePrefill = (form, prefill) => {
  const merged = emptyForm();
  const formData = normalizeApplymentFields((prefill && prefill.form_data) || {});
  const currentForm = normalizeApplymentFields(form || {});

  deepMerge(merged, formData);
  deepMerge(merged, currentForm, { skipEmpty: true });
  merged.applyment_type = "standard";
  delete merged.micro;
  if (STANDARD_SUBJECT_TYPES.indexOf(merged.subject.subject_type) === -1) {
    merged.subject.subject_type = "SUBJECT_TYPE_ENTERPRISE";
  }
  if (merged.subject.card_period_end === "长期") {
    merged.subject.card_period_long_term = 1;
  }

  const subAppid =
    merged.business.mini_program_sub_appid ||
    (prefill && (prefill.sub_appid || prefill.mini_program_sub_appid)) ||
    "";
  if (subAppid) {
    merged.business.mini_program_sub_appid = subAppid;
  }
  if (!Array.isArray(merged.business.sales_scenes_type) || !merged.business.sales_scenes_type.length) {
    merged.business.sales_scenes_type = ["SALES_SCENES_MINI_PROGRAM"];
  }

  return merged;
};

export const storeName = (storeId, storeMap = {}) => {
  const id = Number(storeId || 0);
  if (id === 0) return STORE_PLATFORM_LABEL;
  return storeMap[id] || storeMap[String(id)] || `门店 #${id}`;
};

export const statusText = (status) => {
  const value = isPlainObject(status) ? status.status : status;
  if (isPlainObject(status) && Number(status.is_enabled) === 1) return "已启用";
  return APPLYMENT_STATUS_TEXT[Number(value || 0)] || "同步状态";
};

export const nextActionText = (row) => {
  const value = isPlainObject(row) ? row.status : row;
  if (isPlainObject(row) && Number(row.is_enabled) === 1) return "已启用";
  return NEXT_ACTION_TEXT[Number(value || 0)] || "同步状态";
};

export const applymentStatusValue = (applyment = {}, profile = {}) =>
  Number(
    (isPlainObject(applyment) && applyment.status) ||
      (isPlainObject(profile) && profile.applyment_status) ||
      0
  );

export const confirmUrlForApplyment = (applyment = {}, profile = {}, form = {}) => {
  const info = (isPlainObject(form) && form.account_confirm_info) || {};
  return (
    (isPlainObject(applyment) && (applyment.account_confirm_url || applyment.sign_url)) ||
    (isPlainObject(profile) && (profile.account_confirm_url || profile.sign_url)) ||
    info.account_confirm_url ||
    info.sign_url ||
    ""
  );
};

export const isConfirmQrImageUrl = (url = "") => {
  const value = String(url || "").trim();
  if (!value) return false;

  return (
    value.indexOf("data:image") === 0 ||
    /\/cgi-bin\/showqrcode\?/i.test(value) ||
    /\.(png|jpe?g|gif|webp)([?#].*)?$/i.test(value)
  );
};

export const confirmQrForUrl = (url = "", createQrCodeImg) => {
  const value = String(url || "").trim();
  if (!value) return "";

  if (isConfirmQrImageUrl(value)) return value;

  return typeof createQrCodeImg === "function" ? createQrCodeImg(value) : value;
};

export const canSubmitApplyment = (status) =>
  SUBMITTABLE_STATUS.indexOf(Number(status || 0)) !== -1;

export const canSaveApplymentDraft = (status) => canSubmitApplyment(status);

export const canSyncApplymentStatus = (status) =>
  SYNCABLE_STATUS.indexOf(Number(status || 0)) !== -1;

export const canShowApplymentConfirmCode = (status, confirmUrl = "") =>
  CONFIRMABLE_STATUS.indexOf(Number(status || 0)) !== -1 && !!confirmUrl;

export const canSyncApplymentConfirm = (status, confirmUrl = "") =>
  Number(status || 0) === 40 && !!confirmUrl;

export const canCheckApplymentReadiness = (status) => Number(status || 0) === 50;

export const materialStatusText = (status) =>
  MATERIAL_STATUS_TEXT[status] || status || "待上传";

export const materialText = (material = {}) => {
  if (Array.isArray(material)) {
    if (!material.length) return "待上传";
    if (material.some((item) => item && item.error)) return "上传失败，请重新上传";
    if (material.some((item) => item && (item.ocr_status === "recognizing" || item.recognize_status === "recognizing"))) {
      return "识别中";
    }
    if (material.some((item) => item && (item.ocr_status === "failed" || item.recognize_status === "failed"))) {
      return "识别失败，请手动填写";
    }
    if (material.some((item) => item && (item.asset_id || item.url || item.file_id || item.media_id))) {
      return "已上传";
    }
    return "待上传";
  }
  if (material.error) return "上传失败，请重新上传";
  if (material.ocr_status === "recognizing" || material.recognize_status === "recognizing") return "识别中";
  if (material.ocr_status === "recognized" || material.recognize_status === "recognized" || material.recognized_at) {
    return "已识别，请核对";
  }
  if (material.ocr_status === "failed" || material.recognize_status === "failed") return "识别失败，请手动填写";
  if (material.asset_id || material.url || material.file_id || material.media_id) return "已上传";
  return "待上传";
};

export const normalizeFileRules = (rules) => {
  if (!rules) return [];
  if (Array.isArray(rules)) return rules;
  return Object.keys(rules).map((type) => ({
    type,
    ...(isPlainObject(rules[type]) ? rules[type] : { label: rules[type] }),
  }));
};
